import { AddressDto } from 'dtos'

// TODO - Explain the utility of this function.
export function getComparableAddress({
  addressGuid,
  addressNickname,
  address1,
  address2,
  city,
  stateProvince,
  postalCode,
  country,
  isActive
}: AddressDto): AddressDto {
  return {
    addressGuid,
    addressNickname,
    address1,
    address2,
    city,
    stateProvince,
    postalCode,
    country,
    isActive
  }
}
